import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

import type { ExamplePageContentObject } from './example-page.model.js';
import { Constants } from './example-page.constants.js';
import { PopBaseComponent } from '../../base/pop-base-component.js';

/**
 * @tag pop-example-page-component
 * @attribute {ExamplePageContentObject} [data-component-object] Example Page content
 */
@customElement(Constants.TAG_NAME)
export class ExamplePage extends PopBaseComponent {
  /**
   * @internal
   */
  tagName = Constants.TAG_NAME;

  /**
   * The component object that contains the pre-fetched data to be rendered.
   */
  componentObject?: ExamplePageContentObject;

  constructor() {
    super();
  }

  render() {
    const { overview, literature, summary } = this.componentObject;
    return this.renderComponent(
      html`
        <h1>${this.componentObject?.title}</h1>
        <pop-summary-component
          data-component-object="${JSON.stringify(summary)}"
        ></pop-summary-component>
        <pop-literature-component
          data-component-object="${JSON.stringify(literature)}"
        ></pop-literature-component>
        <pop-overview-component
          data-component-object="${JSON.stringify(overview)}"
        ></pop-overview-component>
      `,
      this.componentObject?.popClasses,
    );
  }
}
